import React, { useMemo, useState, useEffect } from 'react';
import StickyTitle from '../components/StickyTitle.js';
import { MaterialReactTable } from 'material-react-table';
import { Box, Button } from '@mui/material';
import { useAuth } from '../../AuthContext.js';
import Report from '../components/Report.js';
import AllReports from '../components/AllReports.js';

const AccountsPage = () => {

  const { userRole } = useAuth()
  const [employee, setEmployee] = useState(true);
  const [popupData, setPopupData] = useState(null);

  useEffect(() => {
    if (userRole === "manager") {
      setEmployee(false)
    } else {
      setEmployee(true)
    };
  }, [userRole])

  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/clients/all_clients`);
        const responseData = await response.json();
        if (responseData) {
          setData(responseData.client);
        }
      } catch (error) {
        // Handle errors here
        console.error("Error fetching data:", error);
      }
    }
    fetchClients();

  }, []);


  const columns = useMemo(
    () => [
      {
        accessorKey: 'id', //access nested data with dot notation
        header: 'Client ID',
        size: 50,
      },
      {
        accessorKey: 'firstname', //access nested data with dot notation
        header: 'First Name',
        size: 100,
      },
      {
        accessorKey: 'lastname',
        header: 'Last Name',
        size: 100,
      },
      {
        accessorKey: 'companyname', //normal accessorKey
        header: 'Company Name',
        size: 200,
      },
      // {
      //   accessorKey: 'credit',
      //   header: 'Credit',
      //   size: 100,
      //   Cell: ({ cell }) => (
      //     `${cell.getValue() ? Math.round(cell.getValue()) : "Not Available"}`
      //   ),
      // },
      // {
      //   accessorKey: 'debit',
      //   header: 'Debit',
      //   size: 100,
      //   Cell: ({ cell }) => (
      //     `${cell.getValue() ? Math.round(cell.getValue()) : "Not Available"}`
      //   ),
      // },
      {
        header: 'Report',
        size: 200,
        Cell: ({ cell }) => (
          <Box display="flex" alignItems="center" gap="18px">
            <Button
              variant="contained"
              // onClick={() => console.log("Row Data:", cell.row.original)}
              onClick={() => togglePopup(cell.row.original)}
              sx={{ backgroundColor: '#5932EA', borderRadius: '10px', px: '10px', py: '4px', color: 'white', fontSize: '14px' }}
            >
              Generate Report
            </Button>
          </Box>
        ),
      },
    ],
    [],
  );

  const [showPopup, setShowPopup] = useState(false);
  const [showPopupAll, setShowPopupAll] = useState(false);

  const togglePopup = (rowData) => {
    setShowPopup(!showPopup);
    setPopupData(rowData); // Assuming you have a state variable to store the row data
  };

  const togglePopupAll = () => {
    setShowPopupAll(!showPopupAll);
  };

  return (
    <>
      <StickyTitle title="Accounts" no_button={true} />
      <div className=' px-4 lg:px-16 py-4 lg:py-10 flex flex-col gap-0 overflow-x-auto'>

        <div className="table-filters flex flex-col md:flex-row items-start md:items-center justify-center md:justify-between mt-3 mb-3">
          <div className='text-2xl ml-2 font-bold font-poppins'>All Acounts</div>
          <Button
          variant='outlined'
            onClick={() => togglePopupAll()}>
            All Accounts Reports
          </Button>
          {/* <h2 className=' text-end text-sm sm:text-xl text-black'> Total Debt:<span className='ml-1 text-lg md:text-2xl font-bold'>{`QAR ${totalDebt} `}</span></h2> */}
        </div>

        {data ? (<div className="w-full">
          <MaterialReactTable
            columns={columns}
            data={data}
          />
        </div>) : (null)}

        <div className="flex flex-col md:flex-row items-start md:items-center justify-center md:justify-between mt-3 mb-3">

        </div>

        {showPopupAll && (
          <div className="fixed bg-white inset-0 flex items-center overflow-y-auto justify-center z-50">
            <div className="bg-white w-full rounded-lg p-4 shadow-md ">
              <button
                className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 bg-transparent border-5 border-black"
                onClick={togglePopupAll}
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
              <div style={{
                height: '90vh',
                overflowY: 'auto',
              }}>
                <AllReports />
              </div>
            </div>
          </div >
        )}

        {showPopup && (
          <div className="fixed bg-white inset-0 flex items-center overflow-y-auto justify-center z-50">
            <div className="bg-white rounded-lg p-4 shadow-md ">
              <button
                className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 bg-transparent border-5 border-black"
                onClick={togglePopup}
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
              <div style={{
                height: '90vh',
                overflowY: 'auto',
              }}>
                <Report rowData={popupData} />
              </div>
            </div>
          </div >
        )}
      </div>
    </>
  );
};

export default AccountsPage;
